import { render, staticRenderFns } from "./AuthorBox.vue?vue&type=template&id=5a751cd8&"
import script from "./AuthorBox.js?vue&type=script&lang=js&"
export * from "./AuthorBox.js?vue&type=script&lang=js&"
import style0 from "./AuthorBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports